module.exports = __webpack_public_path__ + "img/instagram-empty.c4829353.svg";